/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: bffd752a145b
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  AssetRelationsResponse,
  AssetRelationsResponse$zodSchema,
} from "./assetrelationsresponse.js";
import {
  RelateAssetsByAssetIdRequest,
  RelateAssetsByAssetIdRequest$zodSchema,
} from "./relateassetsbyassetidrequest.js";

export type CreateAssetRelationsByAssetIdGlobals = {
  cloud_name?: string | undefined;
};

export const CreateAssetRelationsByAssetIdGlobals$zodSchema: z.ZodType<
  CreateAssetRelationsByAssetIdGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type CreateAssetRelationsByAssetIdRequest = {
  asset_id: string;
  relate_assets_by_asset_id_request: RelateAssetsByAssetIdRequest;
};

export const CreateAssetRelationsByAssetIdRequest$zodSchema: z.ZodType<
  CreateAssetRelationsByAssetIdRequest
> = z.object({
  asset_id: z.string().describe(
    "The asset ID of the resource. Must be a 32-character hexadecimal string.",
  ),
  relate_assets_by_asset_id_request: RelateAssetsByAssetIdRequest$zodSchema
    .describe("The asset IDs to relate."),
});

export type CreateAssetRelationsByAssetIdResponse =
  | ApiError
  | AssetRelationsResponse;

export const CreateAssetRelationsByAssetIdResponse$zodSchema: z.ZodType<
  CreateAssetRelationsByAssetIdResponse
> = z.union([
  ApiError$zodSchema,
  AssetRelationsResponse$zodSchema,
]);
